import React from "react";
import { FileText, Package, RotateCcw, Settings } from "lucide-react";
import { INVENTORY_VIEW_MODES } from "@/constants/globalConstants";
import { Tabs } from "@/components/ui";

const ICON_MAP = {
  FileText,
  Package,
  RotateCcw,
  Settings
};

export const InventoryTabs = ({
  viewMode, setViewMode,
  activeTab, user
}) => {
  const userRole = user?.role?.toLowerCase().trim();
  const visibleTabs = INVENTORY_VIEW_MODES.filter(tab =>
    !tab.requiredRoles || tab.requiredRoles.includes(userRole)
  );

  const formattedTabs = visibleTabs.map(tab => ({
    id: tab.id,
    label: tab.label,
    icon: ICON_MAP[tab.icon] || FileText
  }));

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-slate-200 overflow-hidden">
      <Tabs 
        tabs={formattedTabs} 
        activeTab={viewMode} 
        onChange={setViewMode} 
        variant="main"
        className="w-full !border-b-0"
      />
    </div>
  );
};

